import { formatQuery } from 'url-lib';
import { REFERRAL_SESSION_KEY } from '../constants';
import { sanitizeRedirectUrl } from '../utils/security';
import { fetchAuthentication, IFetchJSONErrorProps } from './utils';

export const SOCIAL_ACTION_URL = '/ajax/social_action/';

// TODO
export interface ISocialLogInApiResponseProps {
    // canLogin: boolean;
    // exists: boolean;
    // isEmailVerified: boolean;
    // signInMethods: string[];
    isAccountAutolinked: boolean;
    redirectUrl?: string;
    newUser: boolean;
    publicId?: string;
}

// TODO
interface ISocialLogInRawResponseProps {
    // can_login: boolean;
    // exists: boolean;
    // is_email_verified: boolean;
    // sign_in_methods: string[];
    // user_id: string;
    is_account_autolinked: boolean;
    redirect_url?: string;
    public_id?: string;
    new_user: boolean;
    referral_response?: any;
}

/**
 * This calls the social_action endpoint which is responsible for:
 * 1) setting data into redis
 * 2) trying to login the user
 * 3) returning a logged user
 * 4) returning that the user has another account and cannot be logged
 */
export const socialLogIn = (data: {
    sourceProvider: string;
    accessToken: string;
}) =>
    fetchAuthentication(SOCIAL_ACTION_URL, {
        method: 'POST',
        body: formatQuery(data),
    })
        .then((response: ISocialLogInRawResponseProps) => {
            setReferralResponse(response);
            const _response: ISocialLogInApiResponseProps = {
                isAccountAutolinked: response?.['is_account_autolinked'],
                redirectUrl: sanitizeRedirectUrl(response?.['redirect_url']),
                newUser: response?.['new_user'],
                publicId: response?.['public_id'],
            };

            return _response;
        })
        .catch((error: IFetchJSONErrorProps) => {
            // Return the error as a parseed error or an empty object to prevent failures
            throw error.errors || {};
        });

export const setReferralResponse = (response: any) => {
    if (response.referral_response) {
        sessionStorage.setItem(
            REFERRAL_SESSION_KEY,
            JSON.stringify(response.referral_response),
        );
    }
};
